import gql from "graphql-tag";
import { SendInformation } from "../baseTypes";
export default gql`
  mutation ResendTestAdminMultiple($input: [ResendTestAdminInput!]!) {
    resendTestAdminMultiple(input: $input) {
      testId
      date
      sent
    }
  }
`;
export interface ResendTestAdminMultipleMutation {
    resendTestAdminMultiple: Array<SendInformation> | null;
}
